import React from 'react';

import Checkbox, { CHECKBOX_STATE } from '@components/Checkbox';
import Table, { TableProps } from '@components/Table';

type Props<DataType, SelectIdType, DataKeys extends keyof DataType> = TableProps<DataType, DataKeys> & {
  selected: Array<SelectIdType>;
  check: (row: DataType) => void;
  uncheck: (id: SelectIdType) => void;
  checkAll: (rows: Array<DataType>) => void;
  uncheckAll: () => void;
  idGetterFn: (x: DataType) => SelectIdType;
};

const SelectableTable = <DataType extends Record<string, any>, SelectIdType = number, DataKeys extends keyof DataType = keyof DataType>(
  props: Props<DataType, SelectIdType, DataKeys>
): JSX.Element => {
  const { data, columns, selected, check, uncheck, checkAll, uncheckAll, idGetterFn, ...tableProps } = props;
  const isSelected = (id: SelectIdType) => {
    return selected.includes(id);
  };

  const allSelected = data?.length && selected.length === data.length;

  return (
    <Table<DataType & { 'checkbox-column'?: boolean }>
      columns={[
        {
          key: 'checkbox-column',
          header: (
            <Checkbox
              value={allSelected ? CHECKBOX_STATE.CHECKED : selected.length === 0 ? CHECKBOX_STATE.UNCHECKED : CHECKBOX_STATE.INDETERMINATE}
              onChange={() => {
                if (allSelected) {
                  uncheckAll();
                } else {
                  checkAll(data);
                }
              }}
            />
          ),
          style: { width: 50 },
          render: (row) => (
            <Checkbox
              value={isSelected(idGetterFn(row)) ? CHECKBOX_STATE.CHECKED : CHECKBOX_STATE.UNCHECKED}
              onChange={() => {
                if (isSelected(idGetterFn(row))) {
                  uncheck(idGetterFn(row));
                } else {
                  check(row);
                }
              }}
            />
          ),
        },
        ...(columns as any),
      ]}
      data={data}
      {...tableProps}
    />
  );
};

export default SelectableTable;
